import React from "react";
import Card from "./Card";
import {
  LongTermTrading,
  PremiumTradingPeriod,
  ShortTermTrading,
  SignalPackage,
} from "../constants";

import { SiMarketo } from "react-icons/si";
import { styles } from "../styles";
const Plans = () => {
  return (
    <div className="bg-primary-950 py-16">
      <div className=" font-lato pt-16">
        <h2
          className={`${styles.sectionSubText} text-white flex justify-center mb-5`}
        >
          Short Term Plans
        </h2>
        <div className="flex flex-wrap justify-center gap-12">
          {ShortTermTrading.map((plan, index) => (
            <Card
              title="Short Term Plan"
              investment={plan.investment}
              profit={plan.profit}
              rewardIcon={<SiMarketo />} // replace with an actual SVG or icon component
              index={index}
              time="1 Month"
            />
          ))}
        </div>
      </div>

      <div className=" font-lato pt-16">
        <h2
          className={`${styles.sectionSubText} text-white flex justify-center mb-5`}
        >
          Long Term Plans
        </h2>

        <div className="flex flex-wrap justify-center gap-12">
          {LongTermTrading.map((plan, index) => (
            <Card
              title="Long Term Plan"
              investment={plan.investment}
              profit={plan.profit}
              rewardIcon={<SiMarketo />} // replace with an actual SVG or icon component
              index={index}
              time="3 Months"
            />
          ))}
        </div>
      </div>

      <div className=" font-lato pt-16">
        <h2
          className={`${styles.sectionSubText} text-white flex justify-center mb-5`}
        >
          Signal Package
        </h2>

        <div className="flex flex-wrap justify-center gap-12">
          {SignalPackage.map((plan, index) => (
            <Card
              title="Signal Package"
              investment={plan.investment}
              profit={plan.profit}
              rewardIcon={<SiMarketo />}
              index={index}
              time="unlimited"
            />
          ))}
        </div>
      </div>
      <div className=" font-lato pt-16">
        <h2
          className={`${styles.sectionSubText} text-white flex justify-center mb-5`}
        >
          Premium Term Plans
        </h2>

        <div className="flex flex-wrap justify-center gap-12">
          {PremiumTradingPeriod.map((plan, index) => (
            <Card
              title="Premium Term Plan"
              investment={plan.investment}
              profit={plan.profit}
              rewardIcon={<SiMarketo />}
              index={index}
              time="1 Year"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Plans;
